<template lang="pug">
#other-office-online-meetings
  .box
    .box-header
      .d-flex.justify-content-start.align-items-center
        .note
          span 連携済みの他事業所と、オンライン会議（ビデオ通話）ができます（画面共有はできません）。
          br
          span 会議作成には家族連絡サービスのベーシックプラン契約が必要です（会議参加は契約プランに関係なく可能です）。
        .d-flex.justify-content-end.align-items-start.align-self-stretch.flex-fill(v-if="_showRegisterButton")
          button.btn.register-btn(type="button" @click="gotoMeetingRegister") 新規作成
      .error-messages
        .error-message {{ errorMessage }}
    .box-body
      b-tabs(v-model="tabIndex")
        //- future tab
        b-tab.tab(title="予定")
          FutureOnlineMeetingListTab(ref="futureOnlineMeetingListTab" :tabIndex="tabIndex")
        //- history tab
        b-tab.tab(title="履歴")
          HistoryOnlineMeetingListTab(ref="historyOnlineMeetingListTab" :tabIndex="tabIndex")
</template>

<script lang="ts">
import { Component, Ref, Vue } from "vue-property-decorator";
import { Route } from "vue-router";
import { userStore, tabIndexesStore } from "@/store/store";

import { PcUrl } from "@/commons/constants/PcUrl";
import { PlanType } from "@/commons/services/Plans";

import FutureOnlineMeetingListTab from "@/pc/containers/otherOfficeOnlineMeetings/FutureOnlineMeetingListTab.vue";
import HistoryOnlineMeetingListTab from "@/pc/containers/otherOfficeOnlineMeetings/HistoryOnlineMeetingListTab.vue";

/** ナビゲーションガードのフックを使えるようにする */
Component.registerHooks(["beforeRouteLeave"]);

/**
 * ### 他事業所連携 オンライン会議一覧
 *
 */
@Component({
  components: {
    FutureOnlineMeetingListTab,
    HistoryOnlineMeetingListTab
  }
})
export default class OtherOfficeOnlineMeetings extends Vue {
  /** タブインデックス(0始まり) */
  tabIndex: number = 0;

  /** エラーメッセージ */
  errorMessage: string = "";

  @Ref() futureOnlineMeetingListTab!: FutureOnlineMeetingListTab;
  @Ref() historyOnlineMeetingListTab!: HistoryOnlineMeetingListTab;

  get _showRegisterButton(): boolean {
    return userStore.facility.useFamilyService && PlanType.BASIC <= userStore.facility.planType;
  }

  /** ### vue lifecycle mounted */
  public async mounted(): Promise<void> {
    this.$nextTick(() => {
      this.tabIndex = tabIndexesStore.otherOfficeOnlineMeetingsTabIndex;
      tabIndexesStore.setOtherOfficeOnlineMeetingsTabIndex({ index: 0 });
    });
    return;
  }

  /** 新規作成画面へ遷移する */
  public gotoMeetingRegister(): void {
    tabIndexesStore.setOtherOfficeOnlineMeetingsTabIndex({ index: this.tabIndex });
    this.$router.push(PcUrl.OtherOfficeOnlineMeetingRegister);
    return;
  }

  beforeRouteLeave(to: Route, from: Route, next: Function) {
    // 画面を離れる前に現在のフィルタリング条件をVuexに保存
    if (this.$options.name) {
      this.futureOnlineMeetingListTab.setFilterSetting();
      this.historyOnlineMeetingListTab.setFilterSetting();
    }
    next();
  }
}
</script>

<style lang="scss" scoped>
#other-office-online-meetings {
  max-width: 1292px;
  margin-left: auto;
  margin-right: auto;

  .box-header {
    padding-bottom: 0 !important;
  }
  .box-body {
    .tab-title {
      position: relative;
      max-height: 23px;
    }
  }
}
</style>
